import { httpClient } from '@bcba/client-auth';

export const getS3SignedUrl = async (fileName: string) => {
  const { data } = await httpClient.get<{
    s3Key: string;
    url: string;
    sanitizedFilename: string;
  }>(`/documents/getS3SignedUrl?fileName=${fileName}`);

  return data;
};
